module.exports = __webpack_public_path__ + "static/media/supra.86066443.jpg";